import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { DirectivesModule } from "../../directives/directives.module";
import { PipesModule } from "../../pipes/pipes.module";
import { GenericInputModalComponent } from "./generic-input-modal.component";

@NgModule({
  declarations: [GenericInputModalComponent],
  imports: [CoreModule, DirectivesModule, PipesModule],
  exports: [GenericInputModalComponent],
})
export class GenericInputModalModule {}
